import styled from 'styled-components';
import { rootStyle } from "../../styles";
export var ListItem = styled.li.withConfig({
  displayName: "ListItem",
  componentId: "sc-14osqn3-0"
})(["", ";list-style-type:none;"], rootStyle());
/**
* **ListItem** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ListItem) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-list-listitem--default) |  
*
* null
*
* @example
* () => <ListItem>List Item</ListItem>;
*
*/

export default ListItem;